export const HELP_CENTER_EVENT = 'help-center';

export const ARTICLE_LIST_LIMIT = 10;

export const ARTICLE_SUGGESTION_LIMIT = 3;

export const MINIMAL_SEARCH_TOKEN_LENGTH = 2;

export const TICKET_DESCRIPTION_ROW_COUNT = 8;

export const EXTENDED_TICKET_DESCRIPTION_ROW_COUNT = 5;

export const SUPPORTED_TICKET_ATTACHMENT_FILE_EXTENSION =
    'image/*, .xlsx, .xls, .docx, .doc, .pdf, .zip, .rar, .har, .csv, .xml';

export const OPEN_SUPPORT_TICKET_URL_PARAM = 'openSupportTicket';
